import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/cfr-groups'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  create: NoParamEndpointConstructor
  remove: SingleParamEndpointConstructor
  update: SingleParamEndpointConstructor
}

export const cfrGroupsEndpoints: Endpoints = {
  getAll: () => baseUrl,
  create: () => baseUrl,
  remove: (id) => `${baseUrl}/${id}`,
  update: (id) => `${baseUrl}/${id}`,
}
